import {MenuDynamicAccessKey} from '@dms/api/shared';
import {
  useHasActiveHyundaiAuthorizationProfile,
  useImporterReportingIntegrations,
} from '@dms/shared-aftersales';

/**
 * Resolves every MenuDynamicAccessKey to its current value. While the underlying data
 * is loading (or errored) a key resolves to false, so gated menu items stay hidden
 * until the tenant is confirmed to have access — they can only pop in, never appear
 * and then vanish.
 */
export function useMenuDynamicAccess(): Record<MenuDynamicAccessKey, boolean> {
  const {hasActiveHyundaiAuthorizationProfile} = useHasActiveHyundaiAuthorizationProfile();
  const importerReportingIntegrations = useImporterReportingIntegrations();

  return {
    hyundaiDbiReporting: hasActiveHyundaiAuthorizationProfile,
    mercedesMraReporting: importerReportingIntegrations.isMercedesMraEnabled,
    merc5StarReporting: importerReportingIntegrations.isMerc5StarEnabled,
    mercCstarReporting: importerReportingIntegrations.isMercCstarEnabled,
    hyundaiMobisIrisReporting: importerReportingIntegrations.isHyundaiMobisIrisEnabled,
    hondaMonthlyReportReporting: importerReportingIntegrations.isHondaMonthlyReportEnabled,
  };
}
